import { Dialog } from '@mui/material';
import { useEffect } from 'react';
import { AppView } from '../constants';
import { useSetPageName } from '../services/flowManager';
import { ERROR_TYPE, ErrorFallback } from './ErrorFallback';

const GeneralError = ({ resetErrorBoundary }: { resetErrorBoundary: any }) => {
  const setPageName = useSetPageName();
  useEffect(() => {
    setPageName(AppView.GeneralError);
  }, []);

  return (
    <Dialog fullScreen open>
      <ErrorFallback
        onButtonClick={resetErrorBoundary}
        type={ERROR_TYPE.SERVER_ERROR}
      />
    </Dialog>
  );
};

export default GeneralError;
